import { render, staticRenderFns } from "./PostThawMotility.vue?vue&type=template&id=0ecc7b04&scoped=true&"
import script from "./PostThawMotility.vue?vue&type=script&lang=js&"
export * from "./PostThawMotility.vue?vue&type=script&lang=js&"
import style0 from "./PostThawMotility.vue?vue&type=style&index=0&id=0ecc7b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecc7b04",
  null
  
)

export default component.exports